import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { type ComponentPropsWithRef } from 'react';

import s from './Radio.module.css';

const radioVariants = ['default', 'error'] as const;
type RadioVariants = (typeof radioVariants)[number];

export interface RadioProps extends ComponentPropsWithRef<'input'> {
  ariaDisabled?: boolean;
  id: string;
  name: string;
  value: string;
  variant?: RadioVariants;
}

const radioStyleVariants = cva(s.radio, {
  variants: {
    variant: {
      default: '',
      error: s.errorVariant,
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export const Radio = (props: RadioProps) => {
  const {
    ariaDisabled,
    className,
    disabled = false,
    variant = 'default',
    ...attrs
  } = props;

  const appearsDisabled = ariaDisabled || disabled || undefined;

  return (
    <input
      {...attrs}
      aria-disabled={appearsDisabled}
      className={clsx(radioStyleVariants({ variant }), className)}
      disabled={disabled}
      type="radio"
    />
  );
};
